import { render, staticRenderFns } from "./ChangeAllUsersPassword.vue?vue&type=template&id=b4b6b012"
import script from "./ChangeAllUsersPassword.vue?vue&type=script&lang=js"
export * from "./ChangeAllUsersPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports